<script>
  import { preguntas, addDoc } from "../../stores/CES";
  import {
    modalStore,
    dataEdit,
    viewsData,
    updateD,
    panelController,
    modalS,
    updateService,
    validText,
  } from "../../stores/service";
  import { navigate } from "svelte-routing";
  import { userRol } from "../../stores/user";
  import { onMount } from "svelte";
  import Login from "../Login.svelte";



  async function controlModals(o) {
    switch (o) {
      case 1:
        $modalS.reset();
        $modalS.info.title = "Aviso";
        $modalS.info.body = `Complete correctamente el formulario.`;
        $modalS.controllers.btn[0].text = `Aceptar`;
        $modalS.controllers.btn[1].text = `No, cancelar`;
        $modalS.controllers.btn[0].status = true;
        $modalS.controllers.btn[1].status = false;

        let modal = await $modalS.mostrar();
        break;

      default:
        break;
    }
  }

  async function controlData(o) {
    switch (o) {
      case 0:
        /*  cuardar */
        let valid = true;
        /* if (
          !(
            $panelController.viewCE.inputs[0].valid &&
            $panelController.viewCE.inputs[1].valid
          )
        ) {
          valid = false;
        }

        if ($panelController.viewCE.inputs[1].value == 1) {
          if (
            !(
              $panelController.viewCE.inputs[2].valid &&
              $panelController.viewCE.inputs[3].valid
            )
          ) {
            valid = false;
          }

          $panelController.viewCE.inputs[4].value.forEach((item) => {
            if (!item.valid) {
              valid = false;
            }
          });
        } */
        if (valid) {
          createQ();
        } else {
          controlModals(1);
        }
        break;
      case 2:
        /*  Actualiozar datos en ata*/

        navigate("/panel", { replace: true });
        break;

      default:
        break;
    }
  }

  function validT(opc, index) {
    $panelController.viewCE.inputs[index].styletxt = "valid-c";
    $panelController.viewCE.inputs[index].valid = true;

    if (index) {
      4;
    } else {
    }
    switch (opc) {
      case 0:
        $panelController.viewCE.inputs[index].messtxt = "";

        break;

      case 1:
        $panelController.viewCE.inputs[index].messtxt = "Seleccionado.";

        break;

      case 2:
        $panelController.viewCE.inputs[index].messtxt = "Válido";
        break;

      case 3:
        
        $panelController.viewCE.inputs[4].value[index].messtxt = "Válido";

        break;
      case 4:


        break;

      default:
        $panelController.viewCE.inputs[index].messtxt = "Ha ocurrido un error.";
        break;
    }
  }

  function validF(opc, index) {
    $panelController.viewCE.inputs[index].styletxt = "valid-i";
    $panelController.viewCE.inputs[index].valid = false;

    switch (opc) {
      case 0:
        $panelController.viewCE.inputs[index].messtxt = "Formule el pregunta.";
        break;
      case 1:
        $panelController.viewCE.inputs[index].messtxt =
          "Seleccione una opción.";
        break;

      case 2:
        $panelController.viewCE.inputs[index].messtxt = "Seleccione el tipo.";
        break;

      case 3:
        $panelController.viewCE.inputs[index].messtxt =
          "Seleccione el tipo de respuesta.";
        break;
      case 4:
        $panelController.viewCE.inputs[index].messtxt =
          "Seleccione el tamaño de las respuestas.";
        break;
      case 5:
        $panelController.viewCE.inputs[index].messtxt = "No Válido.";
        break;

      case 6:
        $panelController.viewCE.inputs[4].value[index].messtxt = "No Válido.";

        break;

      case 7:
        $panelController.viewCE.inputs[4].value[index].messtxt = "";
        
        break;

      default:
        $panelController.viewCE.inputs[index].messtxt = "Ha ocurrido un error.";
        break;

    }
  }

  function validMode(opc, index) {
    switch (opc) {
      case 1:
        if (validText(0, $panelController.viewCE.inputs[index].value)) {
          validT(2, index);
        } else {
          validF(5, index);
        }

        break;

      case 2:
        if ($panelController.viewCE.inputs[index].value > 0) {
          validT(1, index);
          if ($panelController.viewCE.inputs[3].value > 0 && index == 3) {
            genopc(
              $panelController.viewCE.inputs[3].value,
              $panelController.viewCE.inputs[4].value.length
            );
          }

          if (index == 1 && $panelController.viewCE.inputs[1].value == 1) {
            validF(2, 2);
            validF(4, 3);
          }
        } else {
          validF(1, index);
          if (index == 2) {
            validF(2, index);
          }
          if (index == 3) {
            validF(4, index);
          }
        }

        break;

      case 3:
        if (
          validText(0, $panelController.viewCE.inputs[4].value[index].value)
        ) {
          validT(3, index);
        } else {
          validF(6, index);
        }
        break;

      default:
        break;
    }
  }

  onMount(async () => {

    switch ($panelController.viewCE.opc) {
      case 1:

        document.title = "Ratingg | Nuevo";

        $panelController.viewCE.inputs = [{
      name:'pregunta',
      active: false,
      value: "",
      old: "",
      valid: false,
      styletxt: "",
      messtxt: "",
    },{
      name:'tipo',
      active: false,
      value: 0,
      old: "",
      valid: false,
      styletxt: "",
      messtxt: "",
    },
    {
      name:'check',
      active: false,
      value: '',
      old: "",
      valid: false,
      styletxt: "",
      messtxt: "",
    },
    {
      name:'size',
      active: false,
      value: '',
      old: "",
      valid: false,
      styletxt: "",
      messtxt: "",
    },
    {
      name:'checks',
      active: false,
      value: [],
      old: "",
      valid: false,
      styletxt: "",
      messtxt: "",
    }];

    $panelController.viewCE.btn = [{
      text: "Guardar",
      status: true,
      style: "btn-outline-primary",
      ico:'bi bi-check2-circle'
    },
    {
      text: "Editar",
      status: false,
      style: "btn-outline-primary",
      ico:'bi bi-pencil-square'
    },
    {
      text: "Cancelar",
      status: true,
      style: "btn-outline-danger",
      ico:'bi bi-x-circle'
      
    }];
        break;

      case 2:
        document.title = "Ratingg | Editar";

        $panelController.viewCE.inputs[1].value =
          $panelController.service.listRatinggs[
            $panelController.viewCE.index[0]
          ].rattings[$panelController.viewCE.index[1]].tipo;

        validT(0, 0);

        $panelController.viewCE.inputs[0].value =
          $panelController.service.listRatinggs[
            $panelController.viewCE.index[0]
          ].rattings[$panelController.viewCE.index[1]].pregunta;

        validT(0, 1);

        if ($panelController.viewCE.inputs[1].value == 1) {
          validT(0, 2);
          $panelController.viewCE.inputs[2].value =
            $panelController.service.listRatinggs[
              $panelController.viewCE.index[0]
            ].rattings[$panelController.viewCE.index[1]].checkboxOpc;
          validT(0, 3);
          $panelController.viewCE.inputs[3].value =
            $panelController.service.listRatinggs[
              $panelController.viewCE.index[0]
            ].rattings[$panelController.viewCE.index[1]].checks.length;

          /* $panelController.viewCE.inputs[3].value = [$panelController.service.listRatinggs[$panelController.viewCE.index[0]].rattings[$panelController.viewCE.index[1]].checks]; */
          $panelController.viewCE.inputs[4].value = [];

          genopc($panelController.viewCE.inputs[3].value, 0);

          $panelController.service.listRatinggs[
            $panelController.viewCE.index[0]
          ].rattings[$panelController.viewCE.index[1]].checks.forEach(
            (item, index) => {
              validT(4, index);
              $panelController.viewCE.inputs[4].value[index].value = item;
            }
          );
        }
        break;
      default:
        navigate("/", { replace: true });
        break;
    }
  });

  function createQ() {
    const data = {};
    data.tipo = $panelController.viewCE.inputs[1].value;
    data.pregunta = $panelController.viewCE.inputs[0].value;
    if ($panelController.viewCE.inputs[1].value == 1) {
      data.checkboxOpc = $panelController.viewCE.inputs[2].value;
      data.checks = [];
      $panelController.viewCE.inputs[4].value.forEach((item) => {
        data.checks.push(item.value);
      });
    }

    $panelController.service.listRatinggs[
      $panelController.viewCE.index[0]
    ].rattings.splice($panelController.viewCE.index[1], 1, data);

    updateService();
    navigate("/panel", { replace: true });
  }

  function genopc(s, l) {
    if (l > s) {
      for (let index = s; index < l; index++) {
        $panelController.viewCE.inputs[4].value.splice(index, 1);
        /* if ($panelController.viewCE.inputs[3].value.length ) {
        
      } */
      }
    } else {
      for (let index = l; index < s; index++) {
        $panelController.viewCE.inputs[4].value.splice(index, 0, {
          name: "chack",
          active: true,
          value: "",
          valid: false,
          styletxt: "",
          messtxt: "Llene la opción.",
        });
      }
    }
  }
</script>

<div class="card">
  <div class="card-header">
    <div class="row center f-c">
      <!-- <h3 class='text-sm text-md-lg'>{item.name}</h3>  -->
      <label for="title "
        >{$panelController.service.listRatinggs[
          $panelController.viewCE.index[0]
        ].config.name}</label
      >
    </div>
  </div>
  <div class="card-body">
    <!-- Input de texto -->
    <div class="row">
      <div class="row f-c">
        <label for="date">Fecha: </label>
      </div>
      <div class="row f-c">
        <div
          class="form-group col-md-{$panelController.viewCE.inputs[1].value == 1
            ? '6'
            : '8'}"
        >
          <label for="numero1 f-c"
            >Nueva pregunta # {$panelController.viewPanel.index[1] + 1}</label
          >

          <input
            type="text"
            class="form-control"
            bind:value={$panelController.viewCE.inputs[0].value}
            on:input={() => validMode(1, 0)}
            disabled={$panelController.viewCE.inputs[0].active}
          />

          <p class={$panelController.viewCE.inputs[0].styletxt}>
            {$panelController.viewCE.inputs[0].messtxt}
          </p>
        </div>
        <div
          class="form-group col-md-{$panelController.viewCE.inputs[0].value == 1
            ? '2'
            : '4'}"
        >
          <label for="numero2">Modo:</label>
          <select
            class="form-select"
            aria-label="Default"
            bind:value={$panelController.viewCE.inputs[1].value}
            on:change={() => validMode(2, 1)}
            disabled={$panelController.viewCE.inputs[1].active}
          >
            <option selected value={0}>Seleccione una opción</option>
            <option value={1}>Múltiple</option>
            <option value={2}>3 opciones</option>
            <option value={3}>Rango</option>
            <option value={4}>Abierta</option>
          </select>
          <p class={$panelController.viewCE.inputs[1].styletxt}>
            {$panelController.viewCE.inputs[1].messtxt}
          </p>
        </div>
        {#if $panelController.viewCE.inputs[1].value == 1}
          <div class="form-group col-md-2">
            <label for="numero2">Tipo:</label>
            <select
              class="form-select"
              aria-label="Default"
              bind:value={$panelController.viewCE.inputs[2].value}
              on:change={() => validMode(2, 2)}
              disabled={$panelController.viewCE.inputs[2].active}
            >
              <option selected value={0}>Seleccione una opción</option>
              <option value={1}>Multiple</option>
              <option value={2}>Único</option>
            </select>
            <p class={$panelController.viewCE.inputs[2].styletxt}>
              {$panelController.viewCE.inputs[2].messtxt}
            </p>
          </div>
          <div class="form-group col-md-2">
            <label for="numero2">Tamaño :</label>
            <select
              class="form-select"
              aria-label="Default"
              bind:value={$panelController.viewCE.inputs[3].value}
              on:change={() => validMode(2, 3)}
              disabled={$panelController.viewCE.inputs[3].active}
            >
              <option selected value={0}>Seleccionar</option>
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
              <option value={5}>5</option>
            </select>
            <p class={$panelController.viewCE.inputs[3].styletxt}>
              {$panelController.viewCE.inputs[3].messtxt}
            </p>
          </div>
        {/if}
      </div>
    </div>
  </div>
  <div class="row">
    {#if $panelController.viewCE.inputs[1].value == 1 && $panelController.viewCE.inputs[2].value == 1 && $panelController.viewCE.inputs[4].value.length > 0}
      <label class="f-c">Complete los sondeos correspondientes</label>

      {#each $panelController.viewCE.inputs[4].value as check, index}
        <div class="form-group col-md-12">
          <label class="f-c p-1" for="validationTextarea3"
            >opción {index + 1}</label
          >

          <div class="input-group p-3">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <input
                  type="checkbox"
                  aria-label="Checkbox for following text input"
                />
              </div>
            </div>
            <input
              type="text"
              class="form-control"
              aria-label="Text input with checkbox"
              bind:value={$panelController.viewCE.inputs[4].value[index].value}
              on:input={() => validMode(3, index)}
              required
            />
          </div>
          <p
            class="{$panelController.viewCE.inputs[4].value[index]
              .styletxt} f-c"
          >
            {$panelController.viewCE.inputs[4].value[index].messtxt}
          </p>
        </div>
      {/each}
    {/if}

    {#if $panelController.viewCE.inputs[1].value == 1 && $panelController.viewCE.inputs[2].value == 2 && $panelController.viewCE.inputs[4].value.length > 0}
      <label class="f-c">Complete los preguntas correspondientes</label>

      {#each $panelController.viewCE.inputs[4].value as check, index}
        <div class="form-group col-md-12">
          <label class="f-c p-1" for="validationTextarea4"
            >opción {index + 1}</label
          >
          <div class="input-group p-3">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <input
                  type="radio"
                  aria-label="Radio for following text input"
                />
              </div>
            </div>
            <input
              type="text"
              class="form-control"
              aria-label="Text input with radio button"
              bind:value={$panelController.viewCE.inputs[4].value[index].value}
              on:input={() => validMode(3, index)}
              required
            />
          </div>
          <p
            class="{$panelController.viewCE.inputs[4].value[index]
              .styletxt} f-c"
          >
            {$panelController.viewCE.inputs[4].value[index].messtxt}
          </p>
        </div>
      {/each}
    {/if}
  </div>

  <div class="row">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      {#each $panelController.viewCE.btn as item, idx}
        {#if item.status}
          <button
            class="btn {item.style} m-1"
            on:click={() => {
              controlData(idx);
            }}>
            {item.text}
            <i class="{item.ico}"></i>
            </button
          >
        {/if}
      {/each}
    </div>
  </div>
  <div class="card-footer text-body-secondary">
    {#if 0 < $panelController.viewCE.inputs[1].value}
      <div class="card card-success">
        <div class="card-header">
          <h3 class="card-title">Vista previa.</h3>
        </div>
        <div class="card-body">
          {#if $panelController.viewCE.inputs[1].value == 1 && $panelController.viewCE.inputs[2].value == 0}
            <div class="row">
              <div class="col-sm-6">
                <!-- checkbox -->
                <div class="form-group clearfix">
                  <div class="icheck-primary d-inline">
                    <input type="checkbox" id="checkboxPrimary1" checked />
                    <label for="checkboxPrimary1" />
                  </div>
                  <div class="icheck-primary d-inline">
                    <input type="checkbox" id="checkboxPrimary2" />
                    <label for="checkboxPrimary2" />
                  </div>
                  <div class="icheck-primary d-inline">
                    <label for="checkboxPrimary3"> Multiple</label>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <!-- radio -->
                <div class="form-group clearfix">
                  <div class="icheck-primary d-inline">
                    <input type="radio" id="radioPrimary1" name="r1" checked />
                    <label for="radioPrimary1" />
                  </div>
                  <div class="icheck-primary d-inline">
                    <input type="radio" id="radioPrimary2" name="r1" />
                    <label for="radioPrimary2" />
                  </div>
                  <div class="icheck-primary d-inline">
                    <label for="radioPrimary3"> Único </label>
                  </div>
                </div>
              </div>
            </div>
          {/if}

          {#if $panelController.viewCE.inputs[1].value == 3}
            <div class="row">
              <div class="col-12 p-2">
                <div class="question">
                  <span class="number"
                    >{$panelController.viewPanel.index[1] + 1}.</span
                  >
                  {$panelController.viewCE.inputs[0].value !== ""
                    ? $panelController.viewCE.inputs[0].value
                    : "Aspecto a evaluar"}
                </div>
                {#if $panelController.viewCE.inputs[1].previ === 0}
                  <span class="text-danger"> Muy Malo</span>
                {/if}
                {#if $panelController.viewCE.inputs[1].previ === 1}
                  <span class="text-warning"> Malo</span>
                {/if}
                {#if $panelController.viewCE.inputs[1].previ === 2}
                  <span class="text-secondary"> Regular</span>
                {/if}
                {#if $panelController.viewCE.inputs[1].previ === 3}
                  <span class="text-primary"> Bueno</span>
                {/if}
                {#if $panelController.viewCE.inputs[1].previ === 4}
                  <span class="text-success"> Muy Bueno</span>
                {/if}
                <!-- <div>{cambiarValor(rango)}</div> -->
                <div class="col-12">
                  <input
                    type="range"
                    min="0"
                    max="4"
                    step="1"
                    class="custom-range custom-range-teal"
                    id="customRange3"
                    bind:value={$panelController.viewCE.inputs[1].previ}
                  />
                </div>
              </div>
            </div>
          {/if}

          {#if $panelController.viewCE.inputs[1].value == 1 && $panelController.viewCE.inputs[2].value == 2 && $panelController.viewCE.inputs[4].value.length > 0}
            <div class="question">
              <span class="number"
                >{$panelController.viewPanel.index[1] + 1}.</span
              >
              {$panelController.viewCE.inputs[0].value !== ""
                ? $panelController.viewCE.inputs[0].value
                : "Aspecto a evaluar"}
            </div>

            {#each $panelController.viewCE.inputs[4].value as check, index}
              <div class="options">
                <div class="form-group clearfix">
                  <div class="icheck-primary d-inline">
                    <input
                      type="radio"
                      id="radioPrimary{index}"
                      name="r1"
                      checked
                    />
                    <label for="radioPrimary{index}">
                      {check.value}
                    </label>
                  </div>
                </div>
              </div>
            {/each}
          {/if}
          {#if $panelController.viewCE.inputs[1].value == 1 && $panelController.viewCE.inputs[2].value == 1 && $panelController.viewCE.inputs[4].value.length > 0}
            <div class="question">
              <span class="number"
                >{$panelController.viewPanel.index[1] + 1}.</span
              >
              {$panelController.viewCE.inputs[0].value !== ""
                ? $panelController.viewCE.inputs[0].value
                : "Aspecto a evaluar"}
            </div>
            {#each $panelController.viewCE.inputs[4].value as check, index}
              <div class="options">
                <div class="form-group clearfix">
                  <div class="icheck-primary d-inline">
                    <input
                      type="checkbox"
                      id="radioPrimary{index}"
                      name="r1"
                      checked
                    />
                    <label for="radioPrimary{index}">
                      {check.value}
                    </label>
                  </div>
                </div>
              </div>
            {/each}
          {/if}

          {#if $panelController.viewCE.inputs[1].value == 2}
            <div class="question">
              <span class="number"
                >{$panelController.viewPanel.index[1] + 1}.</span
              >
              {$panelController.viewCE.inputs[0].value !== ""
                ? $panelController.viewCE.inputs[0].value
                : "Aspecto a evaluar"}
            </div>
            <div class="row d.flex align-items-center justify-content-center">
              <!-- <label>Aspecto a evaluar </label> -->
              <div class="col-12 p-2">
                <button
                  type="button"
                  class="btn btn-block btn-lg btnsystem"
                  style="background-color:green">Bueno</button
                >
              </div>
              <div class="col-12 p-2">
                <button
                  type="button"
                  class="btn btn-block btn-lg btnsystem"
                  style="background-color:yellow;color:black;">Regular</button
                >
              </div>
              <div class="col-12 p-2">
                <button
                  type="button"
                  class="btn btn-block btn-lg btnsystem"
                  style="background-color:red">Malo</button
                >
              </div>
            </div>
          {/if}

          {#if $panelController.viewCE.inputs[1].value == 4}
            <form class="">
              <div class="question">
                <span class="number"
                  >{$panelController.viewPanel.index[1] + 1}.</span
                >
                {$panelController.viewCE.inputs[0].value !== ""
                  ? $panelController.viewCE.inputs[0].value
                  : "Aspecto a evaluar"}
              </div>
              <div class="mb-3">
                <textarea class="form-control" id="" placeholder="" />
                <!-- <div class="invalid-feedback">
    Por favor escriba la pregunta.
  </div> -->
              </div>
            </form>
          {/if}
        </div>
      </div>
    {/if}
  </div>
</div>

<style>
  .modal {
    display: block;
  }
  .question {
    margin: 20px 0;
    font-weight: bold;
  }
  .options {
    margin-left: 20px;
  }

  .option {
    margin: 10px 0;
  }
  .number {
    font-size: 1.2em;
    margin-right: 10px;
  }
  .checkbox-option {
    display: flex;
    align-items: center;
  }
  .checkbox-input {
    margin-right: 10px;
  }
  .btnsystem {
    /* background-color:rgb(218, 92, 56); */
    border-radius: 25px;
    color: aliceblue;
    font-size: 24px;
  }
  .form-group {
    margin-bottom: 20px;
  }
  .widget-user-header {
    background-color: rgb(218, 92, 56);
    color: aliceblue;
  }
  h3 {
    text-align: center;
  }
  .f-c {
    text-align: center;
  }
  .valid-c {
    color: green;
  }
  .valid-i {
    color: red;
  }
</style>
